import React, { useState, useEffect } from "react";

const Orders = () => {
  // Static data for now (you can replace this with API data later)
  const [orders, setOrders] = useState([
    {
      id: 1,
      date: "12 Oct 2025",
      status: "Delivered",
      total: "₹1,299.00",
      invoice: "INV-001",
    },
    {
      id: 2,
      date: "08 Oct 2025",
      status: "Processing",
      total: "₹2,499.00",
      invoice: "INV-002",
    },
    {
      id: 3,
      date: "02 Oct 2025",
      status: "Cancelled",
      total: "₹799.00",
      invoice: "INV-003",
    },
  ]);

  // Example of how you can make it dynamic later:
  // useEffect(() => {
  //   fetch("/api/orders")
  //     .then((res) => res.json())
  //     .then((data) => setOrders(data));
  // }, []);

  const styles = {
    container: {
      backgroundColor: "#fdfcf9",
      minHeight: "100vh",
      padding: "60px",
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      color: "#222",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "700",
      marginBottom: "30px",
    },
    tableWrapper: {
      backgroundColor: "#fff",
      border: "1px solid #e5e5e5",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      textAlign: "left",
      backgroundColor: "#f3f3f3",
      padding: "16px 20px",
      fontSize: "16px",
      fontWeight: "600",
      borderBottom: "1px solid #e5e5e5",
    },
    td: {
      padding: "16px 20px",
      fontSize: "15px",
      borderBottom: "1px solid #f0f0f0",
    },
    statusDelivered: {
      color: "#2e8b57",
      fontWeight: "600",
    },
    statusProcessing: {
      color: "#e69500",
      fontWeight: "600",
    },
    statusCancelled: {
      color: "#d9534f",
      fontWeight: "600",
    },
    invoiceLink: {
      color: "#000",
      textDecoration: "underline",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>My Orders</h2>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Order Date</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Total</th>
              <th style={styles.th}>Invoice</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((order) => (
              <tr key={order.id}>
                <td style={styles.td}>{order.date}</td>
                <td style={styles.td}>
                  <span
                    style={
                      order.status === "Delivered"
                        ? styles.statusDelivered
                        : order.status === "Processing"
                        ? styles.statusProcessing
                        : styles.statusCancelled
                    }
                  >
                    {order.status}
                  </span>
                </td>
                <td style={styles.td}>{order.total}</td>
                <td style={styles.td}>
                  <span style={styles.invoiceLink}>{order.invoice}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Orders;
